import { ApiCredentialsRequestResponse } from "@incendium/api";
import { oAuthService } from "Apis";
import { useProjectSharedState } from "./useSharedState";
import { ApiProject } from "@incendium/api";

const defaultCredentials: ApiCredentialsRequestResponse = {
  apiKey: "__apiKey__",
  apiSecret: "__apiSecret__",
};

const fetchOAuthCredentials = async (
  selectedProject: ApiProject,
): Promise<ApiCredentialsRequestResponse> => {
  if (!selectedProject.clientId) {
    return defaultCredentials;
  }
  try {
    const result = await oAuthService.oAuthServiceCredentialsRequest({
      clientId: selectedProject.clientId,
    });
    return {
      apiKey: result.apiKey || "__apiKey__",
      apiSecret: result.apiSecret || "__apiSecret__",
    };
  } catch {
    return defaultCredentials;
  }
};

export const useOAuthCredentials = () => {
  const { state, setState, loading, refetch } =
    useProjectSharedState<ApiCredentialsRequestResponse>(
      "oAuthCredentials",
      defaultCredentials,
      fetchOAuthCredentials,
    );

  return { credentials: state, setCredentials: setState, loading, refetch };
};
